// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2776":"477ecfc0","3107":"9e0b746b","3602":"b348a77f","3664":"b348a77f","4141":"f0b97713","6509":"b348a77f","9504":"b348a77f"}[chunkId] + ".chunk.css";
};